export default __webpack_public_path__ + "media/color/bnb-4fb74de7.svg";